import { uuidSchema as e } from "../common/index.js";
import * as t from "zod";
// src/notifications/notification.schema.ts
var n = t.iso.datetime({ precision: 3 }), r = t.enum([
	"email",
	"sms",
	"voice"
]), i = t.enum(["not-acknowledged", "not-resolved"]), a = t.discriminatedUnion("kind", [
	t.strictObject({
		kind: t.literal("user"),
		userId: e
	}),
	t.strictObject({
		kind: t.literal("schedule"),
		scheduleId: e
	}),
	t.strictObject({
		kind: t.literal("team"),
		teamId: e
	})
]), o = t.strictObject({
	id: e,
	position: t.number().int().nonnegative(),
	delayMinutes: t.number().int().min(0).max(1440),
	condition: i,
	target: a,
	channels: t.array(r).min(1).max(3).refine((e) => new Set(e).size === e.length, "Channels must be unique.")
}), s = t.array(o).min(1).superRefine((e, t) => {
	new Set(e.map((e) => e.id)).size !== e.length && t.addIssue({
		code: "custom",
		message: "Step identities must be unique."
	}), new Set(e.map((e) => e.position)).size !== e.length && t.addIssue({
		code: "custom",
		message: "Step positions must be unique."
	});
}), c = {
	name: t.string().min(1).refine((e) => e.isWellFormed() && !e.includes("\0"), "Policy names must contain valid Unicode without NUL.").refine((e) => e.trim().length >= 1 && e.trim().length <= 120, "Trimmed policy names must contain 1–120 characters.").meta({
		minLength: 1,
		maxLength: 120
	}),
	enabled: t.boolean(),
	steps: s
};
function l(e, t) {
	let n = JSON.stringify(e);
	(n === void 0 || new TextEncoder().encode(n).byteLength > 65536) && t.addIssue({
		code: "custom",
		message: "Policy document exceeds 64 KiB UTF-8."
	});
}
var u = t.strictObject(c).superRefine(l).overwrite((e) => ({
	...e,
	name: e.name.trim()
})), d = t.strictObject({
	expectedVersion: t.number().int().positive(),
	...c
}).superRefine(l).overwrite((e) => ({
	...e,
	name: e.name.trim()
})), f = u, p = t.strictObject({
	id: e,
	team: t.strictObject({
		id: e,
		name: t.string().min(1).max(120)
	}),
	name: c.name,
	version: t.number().int().positive(),
	enabled: t.boolean(),
	stepCount: t.number().int().positive(),
	minDelayMinutes: t.number().int().min(0).max(1440),
	maxDelayMinutes: t.number().int().min(0).max(1440),
	lastUsedAt: n.nullable()
}), m = t.enum([
	"available",
	"inactive-user",
	"inactive-team",
	"inactive-schedule",
	"missing-contact",
	"uncovered",
	"unavailable"
]), h = p.extend({
	steps: s,
	createdAt: n,
	updatedAt: n,
	updatedBy: t.strictObject({
		id: e.nullable(),
		displayName: t.string().max(250).nullable()
	}),
	targetStatus: t.array(t.strictObject({
		stepId: e,
		reason: m
	}))
}), g = t.enum([
	"running",
	"stopped",
	"superseded",
	"finished"
]), _ = t.enum([
	"pending",
	"selected",
	"handling",
	"terminal"
]), v = t.enum([
	"not-submitted",
	"accepted",
	"definitive-failure",
	"unknown"
]), y = t.enum([
	"unconfirmed",
	"delivered",
	"definitive-nondelivery"
]), b = t.enum([
	"complete",
	"condition-skipped",
	"edit-skipped",
	"removed",
	"stopped",
	"superseded",
	"no-recipient",
	"unavailable",
	"exhausted",
	"unknown"
]), x = t.strictObject({
	id: e,
	step: o,
	dueAt: n,
	state: _,
	authorizingRevision: t.number().int().positive().nullable(),
	outcome: b.nullable(),
	recipientCount: t.number().int().nonnegative(),
	acceptedCount: t.number().int().nonnegative(),
	deliveredCount: t.number().int().nonnegative(),
	failedCount: t.number().int().nonnegative(),
	unknownCount: t.number().int().nonnegative()
}), S = t.strictObject({
	id: e,
	policyId: e,
	incidentId: e,
	originalReceipt: n,
	appliedRevision: t.number().int().positive(),
	state: g,
	outcome: b.nullable(),
	finishedAt: n.nullable(),
	nextDueAt: n.nullable(),
	steps: t.array(x),
	nextCursor: t.string().max(2e3).nullable()
}), C = t.strictObject({
	ownerKind: t.enum(["identity", "coverage"]),
	ownerNotificationId: e,
	occurredAt: n,
	teamId: e.nullable(),
	boundedContext: t.strictObject({
		reason: t.enum(["identity-unavailable", "no-one"]),
		affectedCount: t.number().int().positive()
	}),
	correlationId: e
}).superRefine((e, t) => {
	(e.ownerKind === "coverage" != (e.boundedContext.reason === "no-one") || e.ownerKind === "coverage" && e.teamId === null) && t.addIssue({
		code: "custom",
		message: "Warning context must match its producer."
	});
});
export { r as notificationChannelSchema, i as notificationConditionSchema, y as notificationDeliveryEvidenceSchema, n as notificationInstantSchema, b as notificationOutcomeSchema, u as notificationPolicyCreateSchema, f as notificationPolicyDefinitionSchema, h as notificationPolicyDetailSchema, p as notificationPolicySummarySchema, d as notificationPolicyUpdateSchema, S as notificationResponseProgressSchema, g as notificationResponseStateSchema, x as notificationStepProgressSchema, o as notificationStepSchema, _ as notificationStepStateSchema, s as notificationStepsSchema, v as notificationSubmissionStateSchema, m as notificationTargetAvailabilitySchema, a as notificationTargetSchema, C as notificationWarningSchema };

//# sourceMappingURL=notification.schema.js.map